import type React from 'react';

interface Props {
  text: string;
}

const SimpleFormat: React.FC<Props> = ({ text }) => (
  <>
    {text.split('\n').map((line) => (
      <p key={line}>
        {line}
        {line === '' && <>&nbsp;</>}
      </p>
    ))}
  </>
);

export default SimpleFormat;
